// Company data - images are stored locally in /public/images/
// To change images: replace files in /public/images/ folder

export const companyData = {
  name: "DIG AND GROW",
  heroImage: "/images/hero-bg.jpg"
};

export const projectImages = [
  "/images/project-1.jpg",
  "/images/project-2.jpg",
  "/images/project-3.jpg",
  "/images/project-4.jpg"
];
